import React  from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import BG from "../../Assets/Images/splash.jpg";
import {VscHome} from "react-icons/vsc";
import LogoPic from "../../Assets/Images/logo.png";
import L from "leaflet";
import {BiMapAlt} from "react-icons/bi";
import {FaSatellite} from "react-icons/fa";
import {MapContainer,  TileLayer} from "react-leaflet";
import {IoCalendarSharp, IoPlayCircleOutline} from "react-icons/io5";
import MapMarker from "../../Assets/Images/marker-icon.png";
import MapMarkerStart from "../../Assets/Images/mapMarkerStart.png";
import MapMarkerEnd from "../../Assets/Images/mapMarkerEnd.png";
import MapMarkerPoint from "../../Assets/Images/mapMarker.png";
import MapMarkerPark from "../../Assets/Images/mapMarkerPark.png";
import {useParams } from "react-router-dom";
import DatePicker, {DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import API from "../../Services/API";
import TimePicker from 'react-times';
import {toast} from "react-toastify";
import {MdOutlinePauseCircle, MdOutlineRadioButtonChecked, MdOutlineRadioButtonUnchecked} from "react-icons/md";
import 'react-times/css/material/default.css';
import ReactLeafletDriftMarker from "react-leaflet-drift-marker"


let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [32, 32],
});

let StartIcon = L.icon({
    iconUrl: MapMarkerStart,
    iconSize: [40, 40],
});
let EndIcon = L.icon({
    iconUrl: MapMarkerEnd,
    iconSize: [40, 40],
});
let RunIcon = L.icon({
    iconUrl: MapMarkerPoint,
    iconSize: [3, 3],
});
let ParkIcon = L.icon({
    iconUrl: MapMarkerPark,
    iconSize: [35, 35],
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = [36.32, 59.51]
const zoom = 15

const satellite = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
const normal = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

function TrackingHistory(props) {
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [map, setMap] = React.useState(null);
    const [fromDate, setFromDate] = React.useState(new DateObject({calendar: persian}))
    const [toDate, setToDate] = React.useState(new DateObject({calendar: persian}))
    const [dateType, setDateType] = React.useState(1);
    const [timeFrom, setTimeFrom] = React.useState('00:00');
    const [timeTo, setTimeTo] = React.useState('23:59');
    const [path, setPath] = React.useState([]);
    const [movingMarkerPosition, setMovingMarkerPosition] = React.useState([]);
    const [movingMarkerIndex, setMovingMarkerIndex] = React.useState(0);
    const [startMoving, setStartMoving] = React.useState(0);
    const [currentSpeed, setCurrentSpeed] = React.useState(0);
    const [currentDate, setCurrentDate] = React.useState('');



    const clearMap = () => {
        for(let i in map._layers) {
            if(map._layers[i]._path !== undefined) {
                try {
                    map.removeLayer(map._layers[i]);
                }
                catch(e) {
                    console.log("problem with " + e + map._layers[i]);
                }
            }
        }
        map.eachLayer((layer) => {
            if(layer['_latlng']!== undefined)
                layer.remove();
        });
    }
    const drawLine = (pointA ,pointB , color ) => {
        let line = new L.Polyline([pointA, pointB], {
            color: color,
            weight: 3,
            opacity: 1,
            smoothFactor: 1
        });
        line.addTo(map);
    }
    React.useEffect(() => {
        if(startMoving) {
            if(movingMarkerIndex < path.length) {
                setTimeout(() => {
                    setMovingMarkerIndex(movingMarkerIndex + 1)

                }, 2000)
                setMovingMarkerPosition(path[movingMarkerIndex])

                setCurrentDate(path[movingMarkerIndex][3])
                setCurrentSpeed(path[movingMarkerIndex][2])
                map.panTo(new L.LatLng(path[movingMarkerIndex][0], path[movingMarkerIndex][1]));
            }
            else {
                setStartMoving(0);
                setMovingMarkerIndex(0)
            }
        }


    }, [startMoving , movingMarkerIndex , map , path]);

    const loadTracks = () => {
        clearMap();

        setIsLoaded(false);
        const request = {
            date_to: toDate?.toDate?.().getFullYear() + '-' + ((toDate?.toDate?.().getMonth()) - -1) + '-' +toDate?.toDate?.().getDate() + ' ' + timeTo,
            date_from: fromDate?.toDate?.().getFullYear() + '-' + (fromDate?.toDate?.().getMonth()  - -1) + '-' +fromDate?.toDate?.().getDate()   + ' ' + timeFrom ,
        }

        API.getTracks(request,id)
            .then((response) => {
                setIsLoaded(true);
                if(response.data.length > 1) {
                    let path = [];

                    response.data.forEach( (points , index) => {
                        if(index < response.data.length -1 && parseInt(points.speed) > 0 && response.data[index + 1].speed > 0) {
                            const date =  points.date;
                            const speed =  points.speed;
                            const start =  points.start;


                            path.push([parseFloat(points.lat), parseFloat(points.long) ,speed , date ]);
                            if(start) {
                                new L.marker(
                                    [points.lat, points.long],
                                    {icon: RunIcon}
                                ).bindPopup(`<div class='w-100 alert alert-success py-1 text-center'> ${date}</div><div class="text-center alert alert-light py-0">سرعت     ${speed} کیلومتر</div>`)
                                    .addTo(map)
                            }
                            else {
                                new L.marker(
                                    [points.lat, points.long],
                                    {icon: ParkIcon}
                                ).bindPopup(`<div class='w-100 alert alert-success py-1 text-center'> ${date}</div><div class="text-center alert alert-light py-0"> پارک</div>`)
                                    .addTo(map)
                            }

                            const pointA = new L.LatLng(points.lat, points.long);
                            const pointB = new L.LatLng(response.data[index + 1].lat, response.data[index + 1].long);
                            const color = points.speed > 80 ? 'darkred' :   'green';

                                drawLine(pointA , pointB , color)


                        }

                    })
                    setPath(path);
                    setMovingMarkerPosition(path[0])
                    const startDate =  response.data[0]?.date;
                    new L.marker(
                        [response.data[0]?.lat,
                            response.data[0]?.long],
                        {icon: StartIcon}
                    ).bindPopup(`<div class='w-100 alert alert-info py-1 text-center'>نقطه شروع</div><div>${startDate}</div>`)
                        .addTo(map)


                    const endDate =  response.data[response.data.length - 1]?.date;
                    new L.marker(
                        [response.data[response.data.length - 1]?.lat,
                            response.data[response.data.length - 1]?.long],
                        {icon: EndIcon}
                    ).bindPopup(`<div class='w-100 alert alert-warning py-1 text-center'>نقطه پایان</div><div>${endDate}</div>`)
                        .addTo(map)


                    map.panTo(new L.LatLng(response.data[0]?.lat, response.data[0]?.long));
                    window.scrollTo(0, document.body.scrollHeight);
                }

            })

            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const   onTimeChange = (event , type) => {
        const time = event.hour + ":" + event.minute;
        if(type === 'timeFrom') {
            setTimeFrom(time);
            return true;
        }
        setTimeTo(time)
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }



            <section className="container-fluid  overflow-hidden  pb-5 rtl px-0   "
                     style={{backgroundImage: `url('${BG}')`}}>
                <div className="row ">
                    <div className="col-12 ">
                        <nav className="navbar navbar-light bg-white mb-4 p-0 m-0 actionbar  py-2">
                             <span className='mx-3 sign-out' onClick={
                                 () => {
                                     window.location.assign(`/home`)
                                 }
                             }>
                                <VscHome className='mx-1 text-big-2'/>
                                صفحه اصلی
                            </span>
                            <a className="navbar-brand mx-4" href="#">
                               {/* <img src={LogoPic} alt="TelCarNet" className="rounded " width="30"/>*/}
                            </a>

                        </nav>
                    </div>
                </div>

                <div className="row mx-2 mb-3">
                    <div className="col-md-3 ">
                        <div className="row rounded vehicle-list py-2 px-2 border-bottom actionbar mb-3  ">
                            <div className="col-1 pt-2 border-bottom mb-3 pb-2">
                                <IoCalendarSharp className='mt-1'/>
                            </div>
                            <div
                                className="col-10 text-secondary text-center text-small-2 fw-bold pt-3 border-bottom mb-3 pb-2">
                                انتخاب بازه زمانی مورد نظر
                            </div>

                            {
                                dateType === 1 ?
                                    <div className="col-12 mb-1">
                                        <div className="alert alert-success text-small-2 py-1 ">
                                            <MdOutlineRadioButtonChecked className='text-success mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده امروز
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 mb-1"
                                         onClick={ () => {
                                             setDateType(1);
                                             setToDate(new DateObject({calendar: persian}));
                                             setFromDate(new DateObject({calendar: persian}));
                                         }}
                                    >
                                        <div className="alert text-small-2 py-1 ">
                                            <MdOutlineRadioButtonUnchecked className='text-muted mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده امروز
                                        </div>
                                    </div>
                            }

                            {
                                dateType === 4 ?
                                    <div className="col-12 mb-1">
                                        <div className="alert alert-success text-small-2 py-1 ">
                                            <MdOutlineRadioButtonChecked className='text-success mx-2 text-big-3 pt-0' />
                                            سفر فعلی
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 mb-1"
                                         onClick={ () => {
                                             setDateType(4);
                                             setToDate(new DateObject({calendar: persian}));
                                             setFromDate(new DateObject({calendar: persian}));
                                         }}
                                    >
                                        <div className="alert text-small-2 py-1 ">
                                            <MdOutlineRadioButtonUnchecked className='text-muted mx-2 text-big-3 pt-0' />
                                            سفر فعلی
                                        </div>
                                    </div>
                            }

                            {
                                dateType === 5 ?
                                    <div className="col-12 mb-1">
                                        <div className="alert alert-success text-small-2 py-1 ">
                                            <MdOutlineRadioButtonChecked className='text-success mx-2 text-big-3 pt-0' />
                                           آخرین سفر
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 mb-1"
                                         onClick={ () => {
                                             setDateType(5);
                                             setToDate(new DateObject({calendar: persian}));
                                             setFromDate(new DateObject({calendar: persian}));
                                         }}
                                    >
                                        <div className="alert text-small-2 py-1 ">
                                            <MdOutlineRadioButtonUnchecked className='text-muted mx-2 text-big-3 pt-0' />
                                           آخرین سفر
                                        </div>
                                    </div>
                            }
                            {
                                dateType === 2 ?
                                    <div className="col-12 mb-1" >
                                        <div className="alert alert-success text-small-2 py-1 ">
                                            <MdOutlineRadioButtonChecked className='text-success mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده دیروز
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 mb-1"
                                         onClick={ () => {
                                             setDateType(2)
                                             setToDate(new DateObject({calendar: persian}).subtract(1 , 'days'));
                                             setFromDate(new DateObject({calendar: persian}).subtract(1 , 'days'));
                                         }}
                                    >
                                        <div className="alert  text-small-2 py-1 ">
                                            <MdOutlineRadioButtonUnchecked className='text-muted mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده دیروز
                                        </div>
                                    </div>
                            }
                            {
                                dateType === 3 ?
                                    <div className="col-12 mb-1" >
                                        <div className="alert alert-success text-small-2 py-1 ">
                                            <MdOutlineRadioButtonChecked className='text-success mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده تاریخ انتخابی
                                        </div>
                                    </div>
                                    :
                                    <div className="col-12 mb-1"
                                         onClick={ () => {
                                             setDateType(3)
                                         }}
                                    >
                                        <div className="alert  text-small-2 py-1 ">
                                            <MdOutlineRadioButtonUnchecked className='text-muted mx-2 text-big-3 pt-0' />
                                            مسیرهای پیموده شده تاریخ انتخابی
                                        </div>
                                    </div>
                            }

                            {
                                dateType === 3 ?
                                    <React.Fragment>
                                        <div className="col-4 mt-3 text-small-2">
                                            از تاریخ
                                        </div>
                                        <div className="col-8 mt-3">
                                            <DatePicker
                                                defaultValue={fromDate}
                                                onChange={(val) => {
                                                    setFromDate(val);
                                                    setDateType(3)
                                                }}
                                                minDate={new DateObject({calendar: persian}).subtract(30, "days")}
                                                maxDate={new DateObject({calendar: persian})}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-left"
                                            />

                                        </div>
                                        <div className="col-4 mt-3 text-small-2">
                                            تا تاریخ
                                        </div>
                                        <div className="col-8 mt-3">
                                            <DatePicker
                                                defaultValue={toDate}
                                                onChange={(val) => {
                                                    setToDate(val);
                                                    setDateType(3)
                                                }}                                    minDate={new DateObject({calendar: persian}).subtract(30, "days")}
                                                maxDate={new DateObject({calendar: persian})}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-left"
                                            />

                                        </div>
                                    </React.Fragment> : ''
                            }

                            <div className="col-12 border-bottom">
                                &nbsp;
                            </div>
                            <div className="col-4 mt-3 text-small-2">
                                از ساعت
                            </div>
                            <div className="col-8 mt-3 form-group">
                                <TimePicker
                                    timeMode="24"
                                    withoutIcon
                                    time={timeFrom}
                                    timeFormat='HH:MM'
                                    theme="material"
                                    onTimeChange={(event) => onTimeChange (event , 'timeFrom')}

                                />

                            </div>
                            <div className="col-4 mt-3 text-small-2">
                                تا ساعت
                            </div>
                            <div className="col-8 mt-3 form-group">
                                <TimePicker
                                    timeMode="24"
                                    withoutIcon
                                    time={timeTo}
                                    timeFormat='HH:MM'
                                    theme="material"

                                    onTimeChange={(event) => onTimeChange (event , 'timeTo')}

                                />

                            </div>
                            <div className="col-12 mt-4 px-3">
                                <button className='btn btn-primary w-100 text-small-2'
                                onClick={loadTracks}
                                >
                                    مشاهده مسیرهای پیموده شده
                                    &nbsp;
                                    <span className='text-warning'>
                                         {window.localStorage.getItem("CarName")}
                                    </span>

                                </button>
                            </div>
                            {
                                path.length > 1 &&

                            <div className="col-12 mt-4 px-3">
                                <button className={startMoving ? 'btn btn-warning w-100 text-small-2' : 'btn btn-success w-100 text-small-2'}
                                onClick={
                                    () => {
                                        setStartMoving(1 - startMoving)
                                    }
                                }
                                >
                                    {
                                        startMoving === 0 ?
                                            <span>
                                                          شروع

                                    <IoPlayCircleOutline className='mx-2 text-big-5' />
                                            </span> :
                                            <span>
                                                          توقف

                                    <MdOutlinePauseCircle  className='mx-2 text-big-5' />
                                            </span>

                                    }
                                </button>
                            </div>
                            }
                        </div>

                    </div>
                    <div className="col-md-9 ">
                        <div className=" maps-container ">
                            <div className='map-part'>
                                <div
                                    className='satellite-btn'
                                    onClick={
                                        () => {
                                            L.tileLayer(satellite, {}).addTo(map);
                                        }
                                    }
                                >
                                    <FaSatellite className='ms-2'/>
                                    ماهواره ای
                                </div>
                                <div
                                    className='normal-btn'
                                    onClick={
                                        () => {
                                            L.tileLayer(normal, {}).addTo(map);
                                        }
                                    }
                                >
                                    <BiMapAlt className='ms-2'/>
                                    نقشه پیش فرض
                                </div>
                                <MapContainer
                                    center={center}
                                    zoom={zoom}
                                    scrollWheelZoom={true}
                                    className='w-100'
                                    ref={setMap}

                                >

                                    <TileLayer
                                        attribution='&copy; <a href="http://telcarnet.com">TelCarNet</a> contributors'
                                        url={normal}
                                    />

                                    {
                                        movingMarkerPosition.length > 2 &&

                                    <ReactLeafletDriftMarker
                                        // if position changes, marker will drift its way to new position
                                        position={ [movingMarkerPosition[0] , movingMarkerPosition[1]]}
                                        // time in ms that marker will take to reach its destination
                                        duration={900}
                                        icon={DefaultIcon} >

                                    </ReactLeafletDriftMarker>
                                    }
                                </MapContainer>
                            </div>

                        </div>
                        <div className="row tracking-data mx-1 pt-2">
                            <div className="col-6">
                                نام خودرو:
                                &nbsp;
                                {window.localStorage.getItem("CarName")}
                            </div>
                            <div className="col-6 text-start">
                                سرعت:
                                &nbsp;
                                {currentSpeed}
                            </div>
                            <div className="col-12 mt-3">
                                تاریخ و ساعت:
                                &nbsp;
                                {currentDate}
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </React.Fragment>
    );
}

export default TrackingHistory;